import styled from "styled-components";

import { BillingDataFormStyledProps as Props } from "./BillingDataForm.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const BillingDataFormStyled = styled.form<Props>`
  padding: 0 2.4rem;
  padding-bottom: 1.2rem;
  width: 100%;
  margin: 0 auto;
  position: relative;
  background-color: var(--palette-black-s2-l17) !important;

  .field {
    & .DocumentTypeSelect__selectContainer,
    & .DocumentInput__input,
    & .TextInput__input,
    & .EmailInput__input,
    & .PhoneNumberInput__input {
      background-color: var(--palette-black-s2-l21) !important;

      &:not(:hover) {
        border: 0.1rem solid var(--palette-black-s2-l21) !important;
      }
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 3.2rem;
  }

  @media screen and (min-width: ${tablet}px) {
    padding: 1.2rem;
  }

  @media (max-width: ${tablet}px) {
    padding: 1.6rem;
  }

  .active {
    opacity: 1;
  }

  .inactive {
    opacity: 0.5;
  }

  .BillingDataForm {
    &__field {
      & .TextInputWrapper__input-spinner {
        top: 50%;
        translate: 0 -50%;
      }
    }
    &__navbar {
      position: relative;

      @media screen and (min-width: ${tablet}px) {
        display: none;
      }

      .MaxWidth__inner {
        padding: 1.6rem 0;
      }
    }

    &__phone-input {
      position: relative;

      & label.PhoneNumberInput__label {
        z-index: 2;
        left: 5rem;
      }

      & .SelectCountry {
        border: 0.1rem solid var(--palette-gray-s0-l95);

        &__select {
          display: none;
        }
      }
    }

    &__use-saved-address {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &__text {
        font-size: 1.6rem;
        font-weight: 600;
        color: var(--palette-white);
      }
    }

    &__address-select-container {
      width: 100%;
      padding: 0 1.2rem;
      border-radius: 0.4rem;
      border: 0.1rem solid transparent;
      background-color: var(--palette-black-s2-l21);

      &:hover {
        border: 0.1rem solid var(--palette-primary);
      }
    }

    &__address-select {
      width: 100%;
      padding: 0.8rem 0;
      font-family: inherit;
      font-size: 1.6rem;
      border: none;
      outline: none;
      cursor: pointer;
      background: inherit;
      color: var(--palette-white);

      &::placeholder {
        color: #1111117a;
        opacity: 1;
      }
    }

    &__checkbox {
      .Checkbox {
        &__label {
          margin-left: 2rem;
          margin-bottom: 1.2rem;
          text-align: center;
        }
      }
    }

    &__error-message {
      color: var(--palette-red-s60-l60);
      font-size: 1.2rem;
    }

    &__submit-button {
      width: 100%;
      height: 5.6rem;
      font-size: 1.6rem;
      font-weight: 600;
    }
  }
`;

export default BillingDataFormStyled;
